import {isProduction} from "./EnvUtils";

export type UrlType = "aops" | "academy";

function chooseTestServerUrl(params: {
	defaultUrl: string;
	referringTestServer?: string;
	type: UrlType;
}): string {
	const {defaultUrl, referringTestServer, type} = params;
	if (!referringTestServer) {
		return defaultUrl;
	}

	const subdomain = getTestServerSubdomain(referringTestServer);
	if (!subdomain) {
		return defaultUrl;
	}

	const domain = type === "aops" ? "aopstest.com" : "aopsacademy.club";
	return `https://${subdomain}.${domain}`;
}

function getTestServerSubdomain(domain: string): string | null {
	// Parse the format of the referringTestServer cookie value to check if it's an aops/academy domain.
	// Examples of valid domains: xx.aopstest.com, xx.aopsacademy.club, virtual.xx.aopsacademy.club
	const match = domain.match(
		/^(?:.*\.)?([^.]+)\.(aopstest\.com|aopsacademy\.club)$/
	);
	if (!match || !match[1]) {
		return null;
	}

	// Extract only the last subdomain part before .aopstest.com or .aopsacademy.club
	return match[1];
}

function ensureNoTrailingSlash(url: string) {
	// Annihilate ALL trailing slashes because they ruin everything!
	return url.replace(/\/+$/, "");
}

/**
 * Shared logic for resolving URLs based on referring test server cookie.
 * Used by both server actions and client functions.
 */
export function resolveUrl(params: {
	defaultUrl: string;
	referringTestServer?: string | null;
	type: UrlType;
}): string {
	// Always return the environment variable in production
	if (isProduction()) {
		return ensureNoTrailingSlash(params.defaultUrl);
	}

	const url = chooseTestServerUrl({
		defaultUrl: params.defaultUrl,
		referringTestServer: params.referringTestServer ?? undefined,
		type: params.type,
	});
	return ensureNoTrailingSlash(url);
}
